import { Badge } from '@/components/ui/badge';
import type { ReportSeverity, ReportType } from '../api/fraud.api';

const severityVariant: Record<ReportSeverity, 'destructive' | 'warning' | 'secondary'> = {
  high: 'destructive',
  medium: 'warning',
  low: 'secondary',
};

const reportTypeLabel: Record<ReportType, string> = {
  driver_report: 'Driver Report',
  auto_cancellation_rate: 'High Cancellation Rate',
  auto_rapid_booking: 'Rapid Booking Pattern',
  auto_post_accept_cancel: 'Post-Accept Cancel',
};

export function ReportSeverityBadge({ severity }: { severity: ReportSeverity }) {
  return (
    <Badge variant={severityVariant[severity]} className="capitalize">
      {severity}
    </Badge>
  );
}

export function ReportTypeBadge({ type }: { type: ReportType }) {
  const isAuto = type.startsWith('auto_');
  return (
    <span className="inline-flex items-center gap-1 text-sm">
      {isAuto && (
        <span className="text-xs bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 px-1.5 py-0.5 rounded font-medium">
          AUTO
        </span>
      )}
      {reportTypeLabel[type] ?? type}
    </span>
  );
}
